export default __webpack_public_path__ + "static/media/last3.c692d13b.jpg";